import { useMemo } from "react"
import { Link } from "react-router-dom"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useLanguage } from "../i18n/LanguageContext"

const Card = ({ data }) => {
  const { t } = useLanguage()
  const link = (data.naam).toLowerCase();

  const badgeColor = useMemo(() => {
    if (data.capaciteit_vrij == null || data.capaciteit_vrij === 0) return '#FF6B6B'
    if (data.capaciteit_vrij < 20) return '#FF6B6B'
    if (data.capaciteit_vrij < 50) return '#FFD93D'
    return '#6BCB77'
  }, [data.capaciteit_vrij])

  const vrijePlekken = data.capaciteit_vrij == null ? "N/A" : data.capaciteit_vrij === 0 ? t('full') : data.capaciteit_vrij;
  const getTime = (iso) => new Date(iso).toLocaleTimeString('nl-NL', { timeZone: 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit' });
  const tijdDisplay = data.lastFetched ? getTime(data.lastFetched) : "--:--";

  return (
    <article className="card">
      <Link className="card_link" to={"garage/" + link}>
        {link ?
          <img className="card_image" src={require("../img/" + link + ".webp")} alt={t('altGaragePhoto') + " " + data.naam} />
          :
          <Skeleton height="100%" />
        }
        <div className="card_overlay"></div>
        <div className="card_content">
          <div className="card_info">
            <h2>{data.naam || <Skeleton />}</h2>
            <p className="card_updated">{t('updatedAt')} {tijdDisplay}</p>
          </div>
          <div className="card_badge" style={{ backgroundColor: badgeColor }}>
            <span className="card_badge_number">{vrijePlekken}</span>
            <span className="card_badge_label">{t('free')}</span>
          </div>
        </div>
      </Link>
    </article>
  )
}

export default Card
